import { Box, Button, Flex, FormControl, FormLabel, Stack, Text, Textarea, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StrengthAndLimitation, UserAnswer } from '../../interfaes/iep'
import { completeIEPStep, onSaveAnswers } from "../../http/iepAPis";
import { useNavigate } from "react-router-dom";
import CoustomAlertDialog from "../../components/CoustomAlertDialog";
import { canAddStudent } from "../../utils/common";
import { BrandButton, GhostButton } from "../../components/TablePageShell";



type StrengthAndLimitationPropsType = {
    strengthAndLimitation: StrengthAndLimitation[]
    iepId: string
    onGetData: () => void;
    isCompleted: boolean | undefined;
};

export default function StrengthAndLimitationView({ strengthAndLimitation, iepId, onGetData, isCompleted }: StrengthAndLimitationPropsType) {
    const { t, i18n } = useTranslation('iep');
    const [userAnswers, setUserAnswers] = useState<UserAnswer[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast()


    useEffect(() => {
        onManageAnswers();
    }, [strengthAndLimitation]);

    const onManageAnswers = () => {
        let updatedAns: UserAnswer[] = [];
        strengthAndLimitation.forEach((s) => {
            const answer: UserAnswer = {
                questionId: s.questionId,
                iepId: iepId,
                type: s.type,
                content: [s.answer.content]
            }
            updatedAns.push(answer);
        })

        setUserAnswers([...updatedAns])
    }

    const handleSave = async () => {
        setLoading(true);


        for (let i = 0; i < userAnswers.length; i++) {
            try {
                if (!userAnswers[i].content || userAnswers[i].content[0] !== '') {
                    await onSaveAnswers(userAnswers[i])
                    if (i === userAnswers.length - 1) {
                        toast({
                            title: 'Strength and Limitation !',
                            description: "Strength and Limitation saved Successfully!!!",
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                        })
                    }
                }
                onGetData();
            } catch (e) {
                if (i === userAnswers.length - 1) {
                    toast({
                        title: 'Error',
                        description: "Strength and Limitation could not be saved!!!",
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                    })
                }
                console.log(e)
            }
        }
        setLoading(false);



    }

    const handleClose = () => {

        onClose();


    }

    const onCompleteIEP = async () => {
        try {
            setLoading(true)
            await completeIEPStep(iepId, 1, !isCompleted);
            onGetData();
            toast({
                title: 'Strength and Limitation !',
                description: "Strength and Limitation completed Successfully!!!",
                status: 'success',
                duration: 3000,
                isClosable: true,
            })
        } catch (e) {
            console.log(e)
            toast({
                title: 'Error!!',
                description: "Strength and Limitation Could not be completed!",
                status: 'error',
                duration: 3000,
                isClosable: true,
            })
        } finally {
            setLoading(false);
            navigate(-1);
        }


    }

    return (
        <Box mt={'24px'}>
            <Box mb={6} pb={4} borderBottom="1px solid" borderColor="gray.100">
                <Text fontWeight={'900'} fontSize={{ base: '20px', md: '24px' }} color="blue.600">
                    {t('step1')} : {t('step1Title')}
                </Text>
            </Box>

            <Stack spacing={6}>
                {strengthAndLimitation.map((item, index) => (
                    <Box key={item.questionId} p={4} borderRadius="xl" bg="gray.50" transition="all 0.2s" _hover={{ bg: "gray.100" }}>
                        <FormControl>
                            <FormLabel fontWeight="700" fontSize="md" mb={2} color="blue.700">
                                {i18n.language === 'en' ? item.question : item.questionNP}
                            </FormLabel>
                            <Textarea
                                isDisabled={isCompleted || !canAddStudent()}
                                _disabled={{ background: 'gray.50', color: 'gray.800', opacity: 1, cursor: 'not-allowed', borderColor: 'gray.300' }}
                                value={userAnswers[index] ? userAnswers[index].content ? userAnswers[index].content[0] : '' : ''}
                                onChange={(e) => {
                                    let ans = [];
                                    ans.push(e.target.value);
                                    const answer: UserAnswer = {
                                        questionId: item.questionId,
                                        iepId: iepId,
                                        type: item.type,
                                        content: ans
                                    }
                                    let answers = [...userAnswers];
                                    answers[index] = answer;
                                    setUserAnswers(answers)
                                }}
                                variant={"outline"}
                                bg="white"
                                size="md"
                                borderRadius="lg"
                                rows={4}
                                fontSize="md"
                            />
                        </FormControl>
                    </Box>
                ))}
            </Stack>

            <Flex mt={'32px'} direction={{ base: 'column', md: 'row' }} gap={4} justifyContent={'flex-end'}>
                <GhostButton
                    size='lg'
                    isDisabled={loading}
                    onClick={() => navigate(-1)}
                >
                    {t('back')}
                </GhostButton>

                {!isCompleted && (
                    <BrandButton
                        size='lg'
                        isLoading={loading}
                        isDisabled={loading}
                        onClick={handleSave}
                        variant="outline"
                        colorScheme="blue"
                    >
                        {t('save')}
                    </BrandButton>
                )}

                <BrandButton
                    size='lg'
                    onClick={() => onOpen()}
                >
                    {isCompleted ? t('redoStep') : t('completeStep')}
                </BrandButton>
            </Flex>

            <CoustomAlertDialog
                onClose={handleClose}
                onOpen={onOpen}
                isOpen={isOpen}
                onMainAction={onCompleteIEP}
                loading={loading}
                warning={true}
            />
        </Box>
    )
}
